<template>
  <div class="text-center">
    <div v-drag>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-sheet
            :color="variables.primary"
            elevation="10"
            height="80"
            width="80"
            rounded="circle"
            class="ml-auto mini-voice-client m-left type2"
            v-bind="attrs"
            v-on="on"
          >
            <div>
              <!-- <div class="pulse-ring" v-show="isShowRing"></div>
          <div class="pulse-ring2" v-show="isShowSecondRing"></div> -->
              <v-icon size="50" dark class="mt-4" @click="goToActiveCall">
                mdi-phone-in-talk
              </v-icon>
            </div>
          </v-sheet>
        </template>
        <span>Go to active call</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'

import { bus } from '../../../main'
import { mapActions } from 'vuex'
export default {
  name: 'FloatingActiveCall',
  created() {
    bus.$on('isHangUp', val => {
      this.setUiMode('voice')
      if (this.$route.path != '/agent') {
        this.$router.push('/agent')
        setTimeout(() => {
          bus.$emit('isRealHangUp', val)
        }, 1500)
      } else if (val == 'agent') {
        bus.$emit('isRealHangUp', val)
      } else {
        setTimeout(() => {
          bus.$emit('isRealHangUp', val)
        }, 1000)
      }
    })
  },
  beforeDestroy() {
    bus.$off('isHangUp')
  },

  methods: {
    ...mapActions('agent', ['setUiMode']),
    goToActiveCall() {
      this.setUiMode('voice')
      if (this.$route.path != '/agent') {
        this.$router.push('/agent')
      }
    }
  },
  data() {
    return {
      variables: variables
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-voice-client {
  position: absolute;
  bottom: 30px;
  right: 40px;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
</style>
